import { BaseTicketController } from '../../../../../common/base/ticketController';

export class DWSCanceledController extends BaseTicketController {
  constructor(controllerService, ticketService) {
    'ngInject';
    super({ controllerService, ticketService });
  }

  $onInit() {
    super.$onInit();
  }
}
